import {
  ChatBubbleOvalLeftIcon,
  EnvelopeIcon,
  ModalOpenBtn,
  PhoneIcon,
} from "@";

const UserCard = ({ info, isSmsBalanceLow }) => {
  const initials = info?.userName
    ?.split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s.charAt(0))
    .join("")
    .toUpperCase();

  return (
    <div className="relative h-fit overflow-hidden rounded-2xl border border-gray-100 bg-white p-5 dark:border-gray-700/60 dark:bg-gray-800 lg:col-span-2">
      <div className="relative flex flex-col items-start gap-5 md:flex-row">
        {/* Avatar */}
        <div className="relative shrink-0">
          {/* Soft halo */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-0 -z-0 mx-auto h-24 w-24 rounded-full bg-gradient-to-br from-purple-300/40 via-purple-200/30 to-transparent blur-2xl dark:from-purple-700/30"
          />
          <div className="relative inline-flex h-24 w-24 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-purple-700 via-purple-800 to-purple-950 text-white shadow-lg shadow-purple-900/25 ring-2 ring-white/40 dark:from-purple-600 dark:via-purple-700 dark:to-purple-900 dark:ring-gray-700/40">
            <span
              aria-hidden
              className="pointer-events-none absolute inset-0 opacity-15 [background-image:radial-gradient(circle_at_1px_1px,_white_1px,_transparent_0)] [background-size:14px_14px]"
            />
            <span className="relative text-2xl font-bold uppercase tracking-wide">
              {initials || "؟"}
            </span>
          </div>
        </div>

        {/* Info */}
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-purple-700 dark:text-purple-400">
            متبرع
          </p>
          <h2 className="mt-0.5 truncate text-xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-2xl">
            {info?.userName || "—"}
          </h2>

          {/* Contact chips */}
          <div className="mt-3 flex flex-wrap items-center gap-2">
            {info?.email && (
              <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-100 bg-gray-50 px-2.5 py-1 text-xs text-gray-600 dark:border-gray-700 dark:bg-gray-900/60 dark:text-gray-400">
                <EnvelopeIcon className="h-3.5 w-3.5 text-purple-700 dark:text-purple-400" />
                <span className="truncate">{info.email}</span>
              </span>
            )}
            {info?.phone && (
              <span
                dir="ltr"
                className="inline-flex items-center gap-1.5 rounded-full border border-gray-100 bg-gray-50 px-2.5 py-1 font-mono text-xs tabular-nums text-gray-600 dark:border-gray-700 dark:bg-gray-900/60 dark:text-gray-400"
              >
                <PhoneIcon className="h-3.5 w-3.5 text-purple-700 dark:text-purple-400" />
                {info.phone}
              </span>
            )}
          </div>

          {/* Action buttons */}
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <a
              href={`https://wa.me/${info?.phone}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-green inline-flex items-center gap-2 hover:shadow-sm hover:shadow-emerald-700/30"
            >
              <ChatBubbleOvalLeftIcon className="h-5 w-5" />
              <span>ارسل عبر الواتساب</span>
            </a>

            <ModalOpenBtn disabled={isSmsBalanceLow} title="ارسل رسالة نصية">
              <EnvelopeIcon className="h-5 w-5" />
            </ModalOpenBtn>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
